module.exports = __webpack_public_path__ + "img/00004.c54488d2.webp";